/* GlassesBD Lens Selector v3 — Eyeglasses + Sunglass modes */
(function(){
'use strict';

/* ── EYEGLASSES lens data ── */
var TYPES=[
  {id:'single',name:'Single Vision',desc:'One prescription power across the entire lens.',icon:'◎'},
  {id:'progressive',name:'Progressive / Bifocal',desc:'Multiple prescriptions in one lens for near, mid, and far vision.',icon:'◉'},
  {id:'non-rx',name:'Non-Prescription',desc:'Zero power lenses for fashion or blue light protection.',icon:'✦'}
];
var CATS={
  single:[{id:'bluelight',name:'Blue Light / Computer',desc:'Reduces digital eye strain from screens.',icon:'🖥'},{id:'transition',name:'Transition / Photochromic',desc:'Darkens in sunlight, clears indoors.',icon:'☀'},{id:'driving',name:'Driving',desc:'Reduces glare from headlights and reflections.',icon:'🚗'}],
  progressive:[{id:'bluelight',name:'Blue Light / Computer',desc:'Blue light protection with progressive correction.',icon:'🖥'},{id:'transition',name:'Transition / Photochromic',desc:'Progressive lenses that darken in sunlight.',icon:'☀'},{id:'driving',name:'Driving',desc:'Progressive driving lenses for reduced glare.',icon:'🚗'}],
  'non-rx':[{id:'bluelight',name:'Blue Light / Computer',desc:'Protect eyes from screen glare without prescription.',icon:'🖥'},{id:'transition',name:'Transition / Photochromic',desc:'Darkens in sunlight. No prescription needed.',icon:'☀'},{id:'driving',name:'Driving',desc:'Reduce glare without prescription.',icon:'🚗'}]
};
var PKGS={
  'single:bluelight':[
    {id:'anti-blue',vid:51601546871095,name:'Anti-Blue',desc:'Basic blue light protection.',price:650},
    {id:'blu-scratch',vid:51713779106103,name:'Blu+ Anti-Scratch',desc:'Blue light + anti-scratch coating.',price:1250,badge:'popular'},
    {id:'elements',vid:51601546969399,name:'Elements Blue Cut 1.56',desc:'Enhanced blue light filtering.',price:2700},
    {id:'zeiss-blue',vid:51601547034935,name:'Zeiss BlueProtect 1.5',desc:'Premium Zeiss blue light + UV blocking.',price:6850,badge:'popular'},
    {id:'crizal',vid:51601547067703,name:'Crizal Prevencia 1.56',desc:'Essilor premium blue-violet light filter.',price:9100,badge:'premium'},
    {id:'zeiss-smart',vid:51601547133239,name:'Zeiss Digital Smart Life 1.5',desc:'Advanced Zeiss technology for digital life.',price:35000,badge:'zeiss'}
  ],
  'single:transition':[
    {id:'anti-blue-photosun',vid:51601547198775,name:'Anti-Blue Photosun',desc:'Basic photochromic + blue light.',price:1250},
    {id:'transitions-classic',vid:51601547231543,name:'Transitions Classic',desc:'Original Transitions technology.',price:9100,badge:'popular'},
    {id:'zeiss-photofusion',vid:51601547264311,name:'Zeiss Photofusion X',desc:'Fast-adapting Zeiss photochromic.',price:19999,badge:'zeiss'},
    {id:'transition-gen8',vid:51601547329847,name:'Transition Gen 8',desc:'Latest generation, fastest adaptation.',price:22999,badge:'premium'}
  ],
  'single:driving':[
    {id:'zeiss-drivesafe',vid:51601547362615,name:'ZEISS DriveSafe',desc:'Optimized for driving, reduced glare.',price:8950,badge:'popular'},
    {id:'crizal-essidrive',vid:51601547395383,name:'CRIZAL ESSIDRIVE',desc:'Essilor premium driving lens.',price:19800,badge:'premium'}
  ],
  'progressive:bluelight':[
    {id:'prog-anti-blue',vid:51713781694775,name:'Anti-Blue',desc:'Basic blue light for progressive.',price:2600},
    {id:'prog-blu-premium',vid:51713782808887,name:'Blu+ Premium',desc:'Premium blue light protection.',price:6000},
    {id:'prog-crizal-prev',vid:51713783759159,name:'Crizal Prevencia',desc:'Varilux Clear 1.56.',price:20700,badge:'premium'},
    {id:'prog-zeiss-bp',vid:51713783922999,name:'Zeiss BlueProtect',desc:'Light 2D 1.59.',price:26000,badge:'popular'},
    {id:'prog-zeiss-smart',vid:51713784709431,name:'Zeiss SmartLife',desc:'Top-tier Zeiss progressive.',price:39000,badge:'zeiss'}
  ],
  'progressive:transition':[
    {id:'prog-ar-photosun',vid:51713786052919,name:'Anti-Reflection Photosun',desc:'Progressive with photochromic.',price:2900},
    {id:'prog-ab-photosun',vid:51713787265335,name:'Anti-Blue Photosun',desc:'Blue light + photochromic.',price:4400},
    {id:'prog-blu-photosun',vid:51713788313911,name:'Blu+ Premium Photosun',desc:'Premium blue light + photochromic.',price:8000},
    {id:'prog-trans-classic',vid:51713789428023,name:'Transition Classic',desc:'Crizal Rock 1.59.',price:25400,badge:'popular'},
    {id:'prog-zeiss-photo',vid:51713790640439,name:'Zeiss Photofusion X',desc:'ChromeUV 1.59.',price:31700,badge:'zeiss'}
  ],
  'progressive:driving':[
    {id:'prog-essidrive',vid:51713791263031,name:'CRIZAL ESSIDRIVE',desc:'1.56.',price:22050,badge:'popular'},
    {id:'prog-essidrive-gen8',vid:51713791525175,name:'CRIZAL ESSIDRIVE + Gen 8',desc:'1.56 Transition Gen 8.',price:36050,badge:'premium'}
  ]
};
PKGS['non-rx:bluelight']=PKGS['single:bluelight'];
PKGS['non-rx:transition']=PKGS['single:transition'];
PKGS['non-rx:driving']=PKGS['single:driving'];

/* ── SUNGLASS lens data ── */
var SG_PKGS=[
  {id:'sg-basic',vid:51601546871095,name:'Basic',desc:'Standard single vision lens for sunglasses.',price:650},
  {id:'sg-ar',vid:51601547198775,name:'Anti-Reflection',desc:'Reduces glare and reflections for clearer vision.',price:2900,badge:'popular'},
  {id:'sg-polar',vid:51601547362615,name:'GlassesBD Polarized',desc:'Premium polarized lens. Blocks 99% glare.',price:4500,badge:'popular'},
  {id:'sg-zeiss',vid:51601547034935,name:'Zeiss DuraVision',desc:'Zeiss premium sun lens with DuraVision coating.',price:12650,badge:'zeiss'},
  {id:'sg-essilor',vid:51601547067703,name:'Essilor Xperio Polarized',desc:'Top-tier Essilor polarized lens technology.',price:45500,badge:'premium'}
];

/* ── State ── */
var MODE='eyeglasses'; // or 'sunglass'
var STEPS_EG=['Type','Category','Package','Rx','Review'];
var STEPS_SG=['Lens','Rx','Review'];
var S={step:1,lt:null,cat:null,pkg:null,sgPkg:null,
  rx:{rS:'',rC:'',rA:'',lS:'',lC:'',lA:'',pd:'',notes:''},rxM:'manual',
  rxFile:null,rxFileName:'',
  rxErrors:{},rxSaveName:'',rxShowSaved:false,
  fvid:null,fname:'',fcol:'',fprice:0,loading:false,err:null};

/* ── Saved Prescriptions (localStorage) ── */
var SAVE_KEY='glassesbd_saved_rx';
function getSavedRx(){try{return JSON.parse(localStorage.getItem(SAVE_KEY))||[]}catch(e){return[]}}
function putSavedRx(list){try{localStorage.setItem(SAVE_KEY,JSON.stringify(list.slice(0,5)))}catch(e){}}
function saveCurrentRx(name){
  if(!name)return;
  var list=getSavedRx();
  var entry={name:name,rx:JSON.parse(JSON.stringify(S.rx)),date:new Date().toISOString().slice(0,10)};
  // Replace if same name exists
  var idx=-1;list.forEach(function(s,i){if(s.name===name)idx=i});
  if(idx>=0)list[idx]=entry; else list.unshift(entry);
  putSavedRx(list);
}
function deleteSavedRx(index){
  var list=getSavedRx();list.splice(index,1);putSavedRx(list);
}
function loadSavedRx(index){
  var list=getSavedRx();if(!list[index])return;
  S.rx=JSON.parse(JSON.stringify(list[index].rx));
  S.rxErrors={};S.rxShowSaved=false;render();
}

/* ── Rx Validation ── */
var RX_RULES={
  sph:{min:-20,max:20,step:0.25,label:'SPH'},
  cyl:{min:-6,max:6,step:0.25,label:'CYL'},
  axis:{min:1,max:180,step:1,label:'AXIS'},
  pd:{min:40,max:90,step:0.5,label:'PD'}
};
function parseRxVal(val){if(!val||!val.trim())return null;var v=val.replace(/[+]/g,'').trim();var n=parseFloat(v);return isNaN(n)?NaN:n;}
function validateField(key,val){
  var v=parseRxVal(val);
  if(v===null)return null; // empty = no error (optional unless required check)
  if(isNaN(v))return 'Enter a valid number';
  var r;
  if(key==='rS'||key==='lS')r=RX_RULES.sph;
  else if(key==='rC'||key==='lC')r=RX_RULES.cyl;
  else if(key==='rA'||key==='lA')r=RX_RULES.axis;
  else if(key==='pd')r=RX_RULES.pd;
  else return null;
  if(v<r.min||v>r.max)return r.label+' must be '+r.min+' to +'+r.max;
  if(r.step===1&&v%1!==0)return r.label+' must be a whole number';
  if(r.step===0.25&&(Math.round(v*100)%(r.step*100))!==0)return r.label+' must be in 0.25 steps';
  if(r.step===0.5&&(Math.round(v*100)%(r.step*100))!==0)return r.label+' must be in 0.5 steps';
  return null;
}
function validateAllRx(){
  var errs={};
  // SPH required for both eyes
  if(!S.rx.rS||!S.rx.rS.trim())errs.rS='SPH is required';
  else{var e=validateField('rS',S.rx.rS);if(e)errs.rS=e;}
  if(!S.rx.lS||!S.rx.lS.trim())errs.lS='SPH is required';
  else{var e2=validateField('lS',S.rx.lS);if(e2)errs.lS=e2;}
  // CYL optional, but if provided validate
  if(S.rx.rC&&S.rx.rC.trim()){var e3=validateField('rC',S.rx.rC);if(e3)errs.rC=e3;}
  if(S.rx.lC&&S.rx.lC.trim()){var e4=validateField('lC',S.rx.lC);if(e4)errs.lC=e4;}
  // AXIS required if CYL is provided
  if(S.rx.rC&&S.rx.rC.trim()){
    if(!S.rx.rA||!S.rx.rA.trim())errs.rA='Required with CYL';
    else{var e5=validateField('rA',S.rx.rA);if(e5)errs.rA=e5;}
  }else if(S.rx.rA&&S.rx.rA.trim()){var e5b=validateField('rA',S.rx.rA);if(e5b)errs.rA=e5b;}
  if(S.rx.lC&&S.rx.lC.trim()){
    if(!S.rx.lA||!S.rx.lA.trim())errs.lA='Required with CYL';
    else{var e6=validateField('lA',S.rx.lA);if(e6)errs.lA=e6;}
  }else if(S.rx.lA&&S.rx.lA.trim()){var e6b=validateField('lA',S.rx.lA);if(e6b)errs.lA=e6b;}
  // PD optional
  if(S.rx.pd&&S.rx.pd.trim()){var e7=validateField('pd',S.rx.pd);if(e7)errs.pd=e7;}
  return errs;
}
function hasRxErrors(){var e=S.rxErrors;for(var k in e)if(e.hasOwnProperty(k)&&e[k])return true;return false;}

function fp(n){return '৳'+n.toLocaleString('en-IN')}
function pk(){return (S.lt==='progressive'?'progressive':(S.lt==='non-rx'?'non-rx':'single'))+':'+S.cat}
function esc(s){return s?String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'):''}
function steps(){return MODE==='sunglass'?STEPS_SG:STEPS_EG}
function maxStep(){return steps().length}

function getSelectedLens(){
  if(MODE==='sunglass'){
    return SG_PKGS.find(function(p){return p.id===S.sgPkg})||null;
  }
  return (PKGS[pk()]||[]).find(function(p){return p.id===S.pkg})||null;
}

/* ── Render ── */
function render(){
  var a=document.getElementById('lens-selector-app');if(!a)return;
  var lens=getSelectedLens(),lp=lens?lens.price:0,tot=S.fprice+lp;
  var st=steps(),ms=maxStep();
  var h='';

  // Header
  h+='<div class="ls-hdr"><div class="ls-hdr__top">';
  h+='<button class="ls-hdr__back" onclick="LensSelector.back()" '+(S.step<=1?'style="opacity:0;pointer-events:none"':'')+'>←</button>';
  h+='<div style="text-align:center;flex:1"><div class="ls-title">'+(MODE==='sunglass'?'🕶 Power Sunglass':'Select Lens')+'</div><div class="ls-pname">'+esc(S.fname)+'</div></div>';
  h+='<button class="ls-hdr__close" onclick="LensSelector.close()">✕</button></div>';

  // Stepper
  h+='<div class="ls-stepper">';
  for(var i=0;i<ms;i++){var sn=i+1,done=sn<S.step,act=sn===S.step;
    h+='<div class="ls-step"><div class="ls-step__c'+(done?' ls-step__c--done':'')+(act?' ls-step__c--on':'')+'">'+(done?'✓':sn)+'</div>';
    h+='<div class="ls-step__l'+(act?' ls-step__l--on':'')+(done?' ls-step__l--done':'')+'">'+st[i]+'</div></div>';
    if(i<ms-1)h+='<div class="ls-step__ln'+(done?' ls-step__ln--done':'')+'"></div>';
  }
  h+='</div></div>';

  // Body
  h+='<div class="ls-body">';

  if(MODE==='sunglass'){
    // SUNGLASS MODE
    if(S.step===1){
      h+='<div class="ls-body__t">Choose Sunglass Lens</div><div class="ls-body__st">Select lens type for your prescription sunglasses</div>';
      SG_PKGS.forEach(function(p,i){h+=sgCard(p,i)});
    }else if(S.step===2){
      h+=rxUI();
    }else if(S.step===3){
      h+=reviewUI(lens,tot);
    }
  }else{
    // EYEGLASSES MODE
    if(S.step===1){
      h+='<div class="ls-body__t">What type of lenses?</div><div class="ls-body__st">Select based on your vision needs</div>';
      TYPES.forEach(function(t,i){h+=typeCard(t,i)});
    }else if(S.step===2){
      h+='<div class="ls-body__t">Choose category</div><div class="ls-body__st">Select the primary feature</div>';
      (CATS[S.lt]||[]).forEach(function(c,i){h+=catCard(c,i)});
    }else if(S.step===3){
      h+='<div class="ls-body__t">Choose lens package</div><div class="ls-body__st">Select coating & features</div>';
      (PKGS[pk()]||[]).forEach(function(p,i){h+=pkgCard(p,i)});
    }else if(S.step===4){
      h+=rxUI();
    }else if(S.step===5){
      h+=reviewUI(lens,tot);
    }
  }
  h+='</div>';

  // Footer
  h+='<div class="ls-ftr">';
  if(S.step>1)h+='<button class="ls-btn ls-btn--back" onclick="LensSelector.back()">← Back</button>';
  if(lens)h+='<div class="ls-ftr__tot"><div class="ls-ftr__tot-l">Total</div><div class="ls-ftr__tot-p">'+fp(tot)+'</div></div>';
  if(S.step===ms){
    h+='<button class="ls-btn ls-btn--cart'+(S.loading?' ls-btn--loading':'')+'" onclick="LensSelector.addToCart()">'+(S.loading?'Adding...':'🛒 Add to Cart')+'</button>';
  }else{
    h+='<button class="ls-btn ls-btn--next" '+(canNext()?'':'disabled')+' onclick="LensSelector.next()">Continue →</button>';
  }
  h+='</div>';
  if(S.err)h+='<div class="ls-err">'+esc(S.err)+'</div>';
  a.innerHTML=h;

  // Bind Rx inputs
  var isRxStep=(MODE==='sunglass'&&S.step===2)||(MODE==='eyeglasses'&&S.step===4);
  if(isRxStep&&S.rxM==='manual'){bindRxInputs()}
  // Bind drag-drop zone
  if(isRxStep&&S.rxM==='upload'){
    var dz=document.getElementById('rx-drop-zone');
    if(dz){
      ['dragenter','dragover'].forEach(function(ev){dz.addEventListener(ev,function(e){e.preventDefault();e.stopPropagation();dz.style.borderColor='#0ea5e9';dz.style.background='#f0f9ff'})});
      ['dragleave','drop'].forEach(function(ev){dz.addEventListener(ev,function(e){e.preventDefault();e.stopPropagation();dz.style.borderColor='';dz.style.background=''})});
      dz.addEventListener('drop',function(e){
        var f=e.dataTransfer&&e.dataTransfer.files&&e.dataTransfer.files[0];
        if(f){var dt=new DataTransfer();dt.items.add(f);var inp=document.getElementById('rx-file-input');if(inp){inp.files=dt.files;handleFile(inp)}}
      });
    }
  }
}

function bindRxInputs(){
  ['rS','rC','rA','lS','lC','lA','pd'].forEach(function(k){
    var el=document.getElementById('rx-'+k);
    if(el){
      el.value=S.rx[k];
      el.addEventListener('input',function(){
        S.rx[k]=this.value;
        // Real-time validation
        var err=validateField(k,this.value);
        if(this.value&&this.value.trim()){
          S.rxErrors[k]=err;
          this.style.borderColor=err?'#ef4444':'#10b981';
          var errEl=document.getElementById('rx-err-'+k);
          if(errEl)errEl.textContent=err||'';
        }else{
          delete S.rxErrors[k];
          this.style.borderColor='#e2e8f0';
          var errEl2=document.getElementById('rx-err-'+k);
          if(errEl2)errEl2.textContent='';
        }
      });
      // Set initial border if value exists
      if(el.value&&el.value.trim()){
        var initErr=validateField(k,el.value);
        el.style.borderColor=initErr?'#ef4444':'#10b981';
      }
    }
  });
  // Notes (no validation needed)
  var notesEl=document.getElementById('rx-notes');
  if(notesEl){notesEl.value=S.rx.notes;notesEl.addEventListener('input',function(){S.rx.notes=this.value})}
}

/* ── Card builders ── */
function typeCard(t,i){
  var s=S.lt===t.id;
  return '<button class="ls-card'+(s?' ls-card--sel':'')+'" onclick="LensSelector.setType(\''+t.id+'\')" style="animation-delay:'+(i*50)+'ms">'
    +'<span class="ls-card__icon">'+t.icon+'</span>'
    +'<div class="ls-card__bd"><div class="ls-card__nm">'+esc(t.name)+'</div><div class="ls-card__desc">'+esc(t.desc)+'</div></div>'
    +'<div class="ls-card__radio"><span class="ls-card__chk">✓</span></div></button>';
}
function catCard(c,i){
  var s=S.cat===c.id;
  return '<button class="ls-card'+(s?' ls-card--sel':'')+'" onclick="LensSelector.setCat(\''+c.id+'\')" style="animation-delay:'+(i*50)+'ms">'
    +'<span class="ls-card__icon">'+c.icon+'</span>'
    +'<div class="ls-card__bd"><div class="ls-card__nm">'+esc(c.name)+'</div><div class="ls-card__desc">'+esc(c.desc)+'</div></div>'
    +'<div class="ls-card__radio"><span class="ls-card__chk">✓</span></div></button>';
}
function pkgCard(p,i){
  var s=S.pkg===p.id,b='';
  if(p.badge)b='<span class="ls-badge ls-badge--'+p.badge+'">'+p.badge+'</span>';
  return '<button class="ls-card'+(s?' ls-card--sel':'')+'" onclick="LensSelector.setPkg(\''+p.id+'\')" style="animation-delay:'+(i*40)+'ms">'
    +'<div class="ls-card__radio"><span class="ls-card__chk">✓</span></div>'
    +'<div class="ls-card__bd"><div class="ls-card__nm">'+esc(p.name)+b+'</div><div class="ls-card__desc">'+esc(p.desc)+'</div></div>'
    +'<div class="ls-card__pr">+'+fp(p.price)+'</div></button>';
}
function sgCard(p,i){
  var s=S.sgPkg===p.id,b='';
  if(p.badge)b='<span class="ls-badge ls-badge--'+p.badge+'">'+p.badge+'</span>';
  return '<button class="ls-card'+(s?' ls-card--sel':'')+'" onclick="LensSelector.setSgPkg(\''+p.id+'\')" style="animation-delay:'+(i*50)+'ms">'
    +'<div class="ls-card__radio"><span class="ls-card__chk">✓</span></div>'
    +'<div class="ls-card__bd"><div class="ls-card__nm">'+esc(p.name)+b+'</div><div class="ls-card__desc">'+esc(p.desc)+'</div></div>'
    +'<div class="ls-card__pr">+'+fp(p.price)+'</div></button>';
}

/* ── Rx UI ── */
function rxUI(){
  var isNonRx=(MODE==='eyeglasses'&&S.lt==='non-rx');
  if(isNonRx){
    return '<div class="ls-body__t">No prescription needed</div><div class="ls-body__st">Zero power lenses</div>'
      +'<div class="ls-nonrx"><div style="font-size:48px;margin-bottom:8px">✅</div><div style="font-size:16px;font-weight:700">Ready to proceed</div><div style="font-size:13px;color:#64748b">Press Continue to review your order</div></div>';
  }
  var h='<div class="ls-body__t">Enter Prescription</div><div class="ls-body__st">Enter manually or upload a photo/file</div>';

  // Saved prescriptions
  var saved=getSavedRx();
  if(saved.length>0){
    h+='<div class="ls-saved">';
    h+='<button class="ls-saved__toggle" onclick="LensSelector.toggleSaved()">💾 Load Saved Prescription <span style="font-size:10px;color:#94a3b8">('+saved.length+')</span> <span style="font-size:10px">'+(S.rxShowSaved?'▲':'▼')+'</span></button>';
    if(S.rxShowSaved){
      h+='<div class="ls-saved__list">';
      saved.forEach(function(s,i){
        h+='<div class="ls-saved__item">';
        h+='<button class="ls-saved__load" onclick="LensSelector.loadRx('+i+')">';
        h+='<div class="ls-saved__nm">'+esc(s.name)+'</div>';
        h+='<div class="ls-saved__det">SPH R:'+esc(s.rx.rS)+' L:'+esc(s.rx.lS);
        if(s.rx.pd)h+=' · PD:'+esc(s.rx.pd);
        h+='</div></button>';
        h+='<button class="ls-saved__del" onclick="LensSelector.deleteRx('+i+')" title="Delete">✕</button>';
        h+='</div>';
      });
      h+='</div>';
    }
    h+='</div>';
  }

  h+='<div class="ls-rx-tog">';
  h+='<button class="ls-rx-tog__b'+(S.rxM==='manual'?' ls-rx-tog__b--on':'')+'" onclick="LensSelector.setRxM(\'manual\')">📝 Enter Manually</button>';
  h+='<button class="ls-rx-tog__b'+(S.rxM==='upload'?' ls-rx-tog__b--on':'')+'" onclick="LensSelector.setRxM(\'upload\')">📎 Upload File</button></div>';

  if(S.rxM==='manual'){
    h+='<div class="ls-rx-eye"><div class="ls-rx-eye__hd"><span class="ls-rx-eye__badge ls-rx-eye__badge--r">R</span><span class="ls-rx-eye__lbl">Right Eye (OD)</span></div>';
    h+='<div class="ls-rx-flds">'+rxField('SPH *','rS','-2.00')+rxField('CYL','rC','-0.50')+rxField('AXIS','rA','180')+'</div></div>';
    h+='<div class="ls-rx-eye"><div class="ls-rx-eye__hd"><span class="ls-rx-eye__badge ls-rx-eye__badge--l">L</span><span class="ls-rx-eye__lbl">Left Eye (OS)</span></div>';
    h+='<div class="ls-rx-flds">'+rxField('SPH *','lS','-1.75')+rxField('CYL','lC','-0.25')+rxField('AXIS','lA','90')+'</div></div>';
    h+='<div style="display:flex;gap:8px;margin-top:8px">';
    h+='<div style="width:100px"><div class="ls-rx-fld"><label>PD <span style="color:#94a3b8;font-weight:400">(optional)</span></label><input type="text" id="rx-pd" placeholder="63" inputmode="decimal"><div class="ls-rx-err" id="rx-err-pd">'+(S.rxErrors.pd?esc(S.rxErrors.pd):'')+'</div></div></div>';
    h+='<div style="flex:1"><div class="ls-rx-fld"><label>NOTES <span style="color:#94a3b8;font-weight:400">(optional)</span></label><textarea id="rx-notes" rows="2" style="width:100%;padding:9px 10px;border:2px solid #e2e8f0;border-radius:8px;font-size:12px;outline:none;resize:none;font-family:inherit" placeholder="Any special instructions..."></textarea></div></div>';
    h+='</div>';

    // Rx ranges hint
    h+='<div class="ls-rx-hint">SPH: -20.00 to +20.00 · CYL: -6.00 to +6.00 · AXIS: 1–180 · PD: 40–90mm</div>';

    // Save prescription button
    h+='<div class="ls-save-rx">';
    h+='<div class="ls-save-rx__row">';
    h+='<input type="text" id="rx-save-name" class="ls-save-rx__input" placeholder="Save as... (e.g. My Rx)" maxlength="30">';
    h+='<button class="ls-save-rx__btn" onclick="LensSelector.saveRx()">💾 Save</button>';
    h+='</div></div>';
  }else{
    // Upload mode
    h+='<input type="file" id="rx-file-input" accept="image/*,.pdf,.doc,.docx,.jpg,.jpeg,.png,.heic,.webp" style="display:none" onchange="LensSelector.handleFile(this)">';
    if(S.rxFileName){
      // File selected — show preview
      h+='<div class="ls-upload ls-upload--done">';
      h+='<div style="font-size:28px;margin-bottom:6px">✅</div>';
      h+='<div style="font-size:14px;font-weight:700;color:#166534">'+esc(S.rxFileName)+'</div>';
      h+='<div style="font-size:11px;color:#64748b;margin-top:2px">Prescription file ready</div>';
      h+='<button class="ls-upload__change" onclick="document.getElementById(\'rx-file-input\').click()">Change File</button>';
      h+='<button class="ls-upload__remove" onclick="LensSelector.removeFile()">✕ Remove</button>';
      h+='</div>';
    }else{
      // Drop zone
      h+='<div class="ls-upload" id="rx-drop-zone" onclick="document.getElementById(\'rx-file-input\').click()">';
      h+='<div style="font-size:36px;margin-bottom:8px">📄</div>';
      h+='<div style="font-size:14px;font-weight:700;color:#334155">Upload your prescription</div>';
      h+='<div style="font-size:12px;color:#94a3b8;margin-top:4px">Tap to browse or drag & drop</div>';
      h+='<div style="font-size:10px;color:#cbd5e1;margin-top:8px">Images, PDF, Word · Max 5MB</div>';
      h+='</div>';
    }
  }
  return h;
}
function rxField(label,key,ph){
  var errMsg=S.rxErrors[key]||'';
  return '<div class="ls-rx-fld"><label>'+label+'</label><input type="text" id="rx-'+key+'" placeholder="'+ph+'" inputmode="decimal">'
    +'<div class="ls-rx-err" id="rx-err-'+key+'">'+esc(errMsg)+'</div></div>';
}

/* ── Review UI ── */
function reviewUI(lens,tot){
  var h='<div class="ls-body__t">Review your order</div><div class="ls-rev">';
  h+=rr('Frame',esc(S.fname),fp(S.fprice));
  if(MODE==='sunglass'){
    h+=rr('Sunglass Lens',lens?esc(lens.name):'',lens?'+'+fp(lens.price):'');
  }else{
    var lt=(TYPES.find(function(t){return t.id===S.lt})||{}).name||'';
    var cn=(CATS[S.lt]||[]).find(function(c){return c.id===S.cat});cn=cn?cn.name:'';
    h+=rr('Lens Type',esc(lt),'');
    h+=rr('Category',esc(cn),'');
    h+=rr('Package',lens?esc(lens.name):'',lens?'+'+fp(lens.price):'');
  }
  // Rx info
  var isNonRx=(MODE==='eyeglasses'&&S.lt==='non-rx');
  if(!isNonRx){
    if(S.rxM==='manual'&&S.rx.rS){
      var rx='<div class="ls-rev__rx">';
      rx+='<strong style="color:#ef4444">R:</strong> SPH '+esc(S.rx.rS);if(S.rx.rC)rx+=' / CYL '+esc(S.rx.rC);if(S.rx.rA)rx+=' / AXIS '+esc(S.rx.rA);
      rx+='<br><strong style="color:#3b82f6">L:</strong> SPH '+esc(S.rx.lS);if(S.rx.lC)rx+=' / CYL '+esc(S.rx.lC);if(S.rx.lA)rx+=' / AXIS '+esc(S.rx.lA);
      if(S.rx.pd)rx+='<br>PD: '+esc(S.rx.pd)+'mm';rx+='</div>';
      h+='<div class="ls-rev__row"><div><div class="ls-rev__lb">Prescription</div>'+rx+'</div></div>';
    }else if(S.rxM==='upload'&&S.rxFileName){h+=rr('Prescription','📎 '+esc(S.rxFileName),'');}
  }
  h+='<div class="ls-rev__tot"><div class="ls-rev__tot-l">Total</div><div class="ls-rev__tot-p">'+fp(tot)+'</div></div></div>';
  return h;
}
function rr(l,v,p){return '<div class="ls-rev__row"><div><div class="ls-rev__lb">'+l+'</div><div class="ls-rev__val">'+v+'</div></div>'+(p?'<div class="ls-rev__pr">'+p+'</div>':'')+'</div>'}

/* ── Navigation ── */
function canNext(){
  if(MODE==='sunglass'){
    if(S.step===1)return !!S.sgPkg;
    if(S.step===2){
      if(S.rxM==='upload')return !!S.rxFileName;
      // manual: must have SPH for both eyes and no errors
      if(!S.rx.rS||!S.rx.rS.trim()||!S.rx.lS||!S.rx.lS.trim())return false;
      return !hasRxErrors();
    }
    return true;
  }
  if(S.step===1)return !!S.lt;
  if(S.step===2)return !!S.cat;
  if(S.step===3)return !!S.pkg;
  if(S.step===4){
    var isNonRx=(S.lt==='non-rx');
    if(isNonRx)return true;
    if(S.rxM==='upload')return !!S.rxFileName;
    if(!S.rx.rS||!S.rx.rS.trim()||!S.rx.lS||!S.rx.lS.trim())return false;
    return !hasRxErrors();
  }
  return true;
}
function setType(id){S.lt=id;S.cat=null;S.pkg=null;render();setTimeout(function(){S.step=2;render()},200)}
function setCat(id){S.cat=id;S.pkg=null;render();setTimeout(function(){S.step=3;render()},200)}
function setPkg(id){S.pkg=id;render();setTimeout(function(){S.step=4;render()},200)}
function setSgPkg(id){S.sgPkg=id;render();setTimeout(function(){S.step=2;render()},200)}
function setRxM(m){S.rxM=m;S.rxErrors={};render()}
function toggleSaved(){S.rxShowSaved=!S.rxShowSaved;render()}
function saveRxAction(){
  var nameEl=document.getElementById('rx-save-name');
  var name=nameEl?nameEl.value.trim():'';
  if(!name){if(nameEl){nameEl.style.borderColor='#ef4444';nameEl.focus()}return;}
  // Validate first
  S.rxErrors=validateAllRx();
  if(hasRxErrors()){render();return;}
  saveCurrentRx(name);
  // Show confirmation
  var btn=document.querySelector('.ls-save-rx__btn');
  if(btn){btn.textContent='✅ Saved!';btn.style.background='#10b981';setTimeout(function(){render()},1200);}
}
function deleteRxAction(idx){deleteSavedRx(idx);render()}
function handleFile(input){
  var file=input&&input.files&&input.files[0];
  if(!file)return;
  if(file.size>5*1024*1024){S.err='File too large. Maximum 5MB.';render();return;}
  S.rxFileName=file.name;
  S.rxFile=file; // Keep raw File object for Shopify FormData upload
  S.err=null;
  render();
}
function removeFile(){S.rxFileName='';S.rxFile=null;render()}
function next(){
  if(S.step<maxStep()&&canNext()){
    // Run full validation on Rx step before advancing
    var isRxStep=(MODE==='sunglass'&&S.step===2)||(MODE==='eyeglasses'&&S.step===4);
    var isNonRx=(MODE==='eyeglasses'&&S.lt==='non-rx');
    if(isRxStep&&S.rxM==='manual'&&!isNonRx){
      S.rxErrors=validateAllRx();
      if(hasRxErrors()){render();return;}
    }
    S.step++;render();
  }
}
function back(){if(S.step>1){S.step--;render()}}

/* ── Add to Cart ── */
function addToCart(){
  var lens=getSelectedLens();if(!lens)return;
  S.loading=true;S.err=null;render();
  var lensType,category;
  if(MODE==='sunglass'){
    lensType='Prescription Sunglass';category=lens.name;
  }else{
    lensType=(TYPES.find(function(t){return t.id===S.lt})||{}).name||'';
    var cs=CATS[S.lt]||[];category=(cs.find(function(c){return c.id===S.cat})||{}).name||'';
  }
  var isNonRx=(MODE==='eyeglasses'&&S.lt==='non-rx');

  // Build lens properties
  var lProps={'_bundle_role':'lens','Paired Frame':S.fname,'Lens Type':lensType,'Category':category};
  if(!isNonRx){
    if(S.rxM==='manual'&&S.rx.rS){
      var re='SPH '+S.rx.rS;if(S.rx.rC)re+=' / CYL '+S.rx.rC;if(S.rx.rA)re+=' / AXIS '+S.rx.rA;
      var le='SPH '+S.rx.lS;if(S.rx.lC)le+=' / CYL '+S.rx.lC;if(S.rx.lA)le+=' / AXIS '+S.rx.lA;
      lProps['Right Eye (OD)']=re;lProps['Left Eye (OS)']=le;
      if(S.rx.pd)lProps['PD']=S.rx.pd+'mm';
      if(S.rx.notes)lProps['Notes']=S.rx.notes;
    }else if(S.rxM==='upload'&&S.rxFileName){
      lProps['Prescription']='File: '+S.rxFileName;
    }
    else{lProps['Prescription']='Not provided — contact customer';}
  }else{lProps['Prescription']='Non-Prescription (Zero Power)'}

  var fProps={'_bundle_role':'frame','Paired Lens':lens.name,'Lens Type':lensType};
  if(S.fcol)fProps['Color']=S.fcol;

  // If file upload: use FormData for lens item (Shopify stores file on CDN),
  // then add frame item via JSON. Otherwise add both via JSON.
  var hasFile=(S.rxM==='upload'&&S.rxFile&&!isNonRx);

  function addFrame(){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:S.fvid,quantity:1,properties:fProps}]})});
  }
  function onSuccess(){
    S.loading=false;
    if(typeof updateCartCount==='function')updateCartCount(null);
    var a=document.getElementById('lens-selector-app');
    a.innerHTML='<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 20px;text-align:center;min-height:300px">'
      +'<div style="font-size:48px;margin-bottom:12px">✅</div>'
      +'<div style="font-size:20px;font-weight:800;margin-bottom:6px">Added to Cart!</div>'
      +'<div style="font-size:13px;color:#64748b;margin-bottom:4px">'+esc(S.fname)+' + '+esc(lens.name)+'</div>'
      +'<div style="font-size:18px;font-weight:800;color:#0284c7;margin-bottom:20px">'+fp(S.fprice+lens.price)+'</div>'
      +'<div style="display:flex;gap:10px"><button class="ls-btn ls-btn--back" onclick="LensSelector.close()">Continue Shopping</button>'
      +'<a href="/cart" class="ls-btn ls-btn--cart" style="text-decoration:none">View Cart →</a></div></div>';
    setTimeout(function(){if(typeof openCartDrawer==='function')openCartDrawer(true)},500);
  }
  function onError(e){S.loading=false;S.err=(e&&e.message)||'Something went wrong.';render();}

  if(hasFile){
    // Step 1: Add lens item via FormData (file becomes Shopify CDN link)
    var fd=new FormData();
    fd.append('id',lens.vid);
    fd.append('quantity','1');
    Object.keys(lProps).forEach(function(k){fd.append('properties['+k+']',lProps[k])});
    fd.append('properties[Prescription File]',S.rxFile,S.rxFileName);

    fetch('/cart/add.js',{method:'POST',body:fd})
    .then(function(r){if(!r.ok)throw new Error('Failed to add lens');return r.json()})
    .then(function(){
      // Step 2: Add frame item via JSON
      return addFrame();
    })
    .then(function(r){if(!r.ok)throw new Error('Failed to add frame');return r.json()})
    .then(onSuccess)
    .catch(onError);
  }else{
    // No file — add both items via JSON in one request
    var items=[{id:S.fvid,quantity:1,properties:fProps},{id:lens.vid,quantity:1,properties:lProps}];
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){if(!r.ok)throw new Error('Failed');return r.json()})
    .then(onSuccess)
    .catch(onError);
  }
}

/* ── Open / Close ── */
function open(cfg){
  MODE=cfg.mode||'eyeglasses';
  S={step:1,lt:null,cat:null,pkg:null,sgPkg:null,
    rx:{rS:'',rC:'',rA:'',lS:'',lC:'',lA:'',pd:'',notes:''},rxM:'manual',
    rxFile:null,rxFileName:'',
    rxErrors:{},rxSaveName:'',rxShowSaved:false,
    fvid:cfg.frameVariantId,fname:cfg.frameName||'',fcol:cfg.frameColor||'',fprice:cfg.framePrice||0,loading:false,err:null};
  document.getElementById('lens-selector-modal').style.display='flex';
  document.body.style.overflow='hidden';
  render();
}
function close(){
  document.getElementById('lens-selector-modal').style.display='none';
  document.body.style.overflow='';
}

window.LensSelector={open:open,close:close,next:next,back:back,
  setType:setType,setCat:setCat,setPkg:setPkg,setSgPkg:setSgPkg,
  setRxM:setRxM,addToCart:addToCart,
  toggleSaved:toggleSaved,saveRx:saveRxAction,loadRx:loadSavedRx,deleteRx:deleteRxAction,
  handleFile:handleFile,removeFile:removeFile};
})();
